// extracted by mini-css-extract-plugin
export default {"keyLostPage":"styles_keyLostPage__MaPZv"};